<template>
    <div>
        <!-- error summary starts -->
        <error-summary :errors="errors"></error-summary>
        <!-- error summary ends -->


        <div class="row">
            <div class="column small-12 medium-12 end">
                <form id="activation_form" class="form--full-width form--transparent-fieldsets" @submit.prevent="submit()" action="" method="">

                        <label for="username"
                               class="form__label"
                               v-bind:class="{ 'form__label--error': errors.hasFieldError('username') }">
                            Username <span class="required">*</span>
                        </label>
                        <input type="text"
                               name="username"
                               id="username"
                               class="form__input"
                               v-model="params.username"
                               v-on:keydown="resetErrors()"
                               v-bind:class="{ 'form__input--error': errors.hasFieldError('username') }"
                               v-bind:aria-invalid="errors.hasFieldError('username')"
                        />
                        <div id="usernameError" aria-live="polite"
                             v-if="errors.hasFieldError('username') && errors.getFieldErrorMessages('username').length > 0"
                             v-bind:class="{ 'form__inline-error-message': errors.hasFieldError('username') }"
                        >
                            <div v-bind:key="message"
                                 v-for="message in errors.getFieldErrorMessages('username')">
                                {{ message }}
                            </div>
                        </div>
                        <label for="pinNumber"
                               class="form__label"
                               v-bind:class="{ 'form__label--error': errors.hasFieldError('pinNumber') }">
                            Registration PIN <span class="required">*</span>
                        </label>
                        <input type="text"
                               name="pinNumber"
                               id="pinNumber"
                               class="form__input"
                               v-model="params.pinNumber"
                               v-on:keydown="resetErrors()"
                               v-bind:class="{ 'form__input--error': errors.hasFieldError('pinNumber') }"
                               v-bind:aria-invalid="errors.hasFieldError('pinNumber')"
                        />
                        <div id="pinNumberError" aria-live="polite"
                             v-if="errors.hasFieldError('pinNumber') && errors.getFieldErrorMessages('pinNumber').length > 0"
                             v-bind:class="{ 'form__inline-error-message': errors.hasFieldError('pinNumber') }"
                        >
                            <div v-bind:key="message"
                                 v-for="message in errors.getFieldErrorMessages('pinNumber')">
                                {{ message }}
                            </div>
                        </div>



                    <button class="button"
                            v-bind:disabled="disabledBtn">
                        Continue
                    </button>
                </form>
            </div>
        </div>

    </div>
</template>
<script src="/javascript/Rpc.js"></script>
<script src="/javascript/script.js"></script>
<script>
import ErrorSummary
    from "../../Shared/VueComponents/ErrorSummary";
import PageLoader
    from "../../Shared/VueComponents/PageLoader";

export default {
    name: "AuthenticateByPinNumberPage",
    components: {
        ErrorSummary,
        PageLoader
    },
    data() {
        return {
            params: {
                username: '',
                pinNumber: '',
            },
            submitted: false,
            disabledBtn: false,
            errors: new StructuredError({}),
            titleOptions: []
        };
    },
    props:{
        token:{
            type: String,
            required: true,
        },
        type:{
            type: String,
            required: true,
        },
    },
    mounted () {

    },
    methods:{

        submit: function(e) {

            this.disabledBtn         = true;
            this.validate();
            if ( this.errors.data.length > 0 )
            {
                this.disabledBtn        = false;

                return false;
            }

            let params              = this.params;
            params.token            = this.token;
            params.type             = this.type;

            let rpc                 = new RpcRequest('Activation.RpcValidatePinNumber', params);
            let that                = this;
            rpc.send(function(res) {

                window.location.href    = res.result.redirect;
                that.disabledBtn        = false;

            }, function(res) {

                that.errors             = res.getErrors();
                that.disabledBtn        = false;
            });
        },
        validate() {

            this.errors             = new StructuredError({});
            let data                = [];
            if ( ! this.params.username.length > 0 )
            {
                data.push(new FieldError('username', ['username cannot be empty.']));
            }
            if ( ! this.params.pinNumber.length > 0 )
            {
                data.push(new FieldError('pinNumber', ['Registration pin cannot be empty.']));
            }

            if ( data.length > 0 )
            {
                this.errors                     = new StructuredError({data: data, message: ""})
            }
        },

        resetErrors(){
            this.errors                     = new StructuredError({});
        }
    },
}
</script>
<style type="text/css" lang="css">
@import '/asset/20200624/css/uq_standard.css';
@import '/asset/20200624/css/identity-portal.css';
</style>
<!--

node_modules/@vue/cli-service/bin/vue-cli-service.js build --target wc Pages/Activation/AuthenticateByPinNumber/AuthenticateByPinNumberPage.vue --dest ./public/Pages/Activation/AuthenticateByPinNumber/AuthenticateByPinNumberPage

-->